import { render, staticRenderFns } from "./VillagesList.vue?vue&type=template&id=69c313b4&scoped=true&"
import script from "./VillagesList.vue?vue&type=script&lang=js&"
export * from "./VillagesList.vue?vue&type=script&lang=js&"
import style0 from "./VillagesList.vue?vue&type=style&index=0&id=69c313b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c313b4",
  null
  
)

export default component.exports